import { apiSlice } from '../apiSlice';
import { DeleteResponse } from '../schemas/apiResponse';
import { PaginatedArgs, PaginatedResponse } from '../schemas/pagination';
import { Upload } from '../schemas/upload';
import { filterParamsAdapter } from '../utils/filterParamsAdapter';
import { providesList } from '../utils/providesList';

type UploadFilterParams = {
  id__in?: string[];
  device_id__in?: string[];
  device_id__like?: string;
  collection_id__in?: string[];
};

const UPLOADS_PATH = '/uploads';

const uploadEndpoints = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllUploads: builder.query<
      PaginatedResponse<Upload>,
      (UploadFilterParams & PaginatedArgs) | void
    >({
      query: (params) => ({
        url: UPLOADS_PATH,
        params: params ? filterParamsAdapter(params) : undefined,
      }),
      providesTags: (result) => providesList(result?.items, 'Upload'),
    }),

    getUploadsForCollection: builder.query<PaginatedResponse<Upload>, string>({
      query: (collectionId) => ({
        url: UPLOADS_PATH,
        params: filterParamsAdapter({ collection_id__in: [collectionId] }),
      }),
      providesTags: (result) => providesList(result?.items || [], 'Upload'),
    }),

    getUpload: builder.query<Upload, string>({
      query: (id) => `${UPLOADS_PATH}/${id}`,
      providesTags: (result, error, id) => [{ type: 'Upload', id }],
    }),

    deleteUpload: builder.mutation<DeleteResponse, string>({
      query(id) {
        return {
          url: `${UPLOADS_PATH}/${id}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: (result, error, id) => [{ type: 'Upload', id }],
    }),
  }),
});

export const {
  useGetAllUploadsQuery,
  useGetUploadsForCollectionQuery,
  useGetUploadQuery,
  useDeleteUploadMutation,
} = uploadEndpoints;
